/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_MASTER_COMPANY = 'REQUEST_MASTER_COMPANY';
export const REQUEST_MASTER_COMPANY_SUCCESS = 'REQUEST_MASTER_COMPANY_SUCCESS';
export const REQUEST_MASTER_COMPANY_FAILURE = 'REQUEST_MASTER_COMPANY_FAILURE';


export const REQUEST_UPDATE_MASTER_COMPANY = 'REQUEST_UPDATE_MASTER_COMPANY';
export const REQUEST_UPDATE_MASTER_COMPANY_SUCCESS = 'REQUEST_UPDATE_MASTER_COMPANY_SUCCESS';
export const REQUEST_UPDATE_MASTER_COMPANY_FAILURE = 'REQUEST_UPDATE_MASTER_COMPANY_FAILURE';
